import { extendTheme } from "@chakra-ui/react"

const theme = extendTheme({
    colors: {
        primary: "#FF003D",
        secondary: "#101010",
        tertiary: "#242424",
        text: "#fff",
    },
})

export default theme